export default "__VITE_PUBLIC_ASSET__a788e7c5__"